"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _checkCircle = _interopRequireDefault(require("@atlaskit/icon/core/check-circle"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const EmojiProductivityIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" role="presentation"><g fill="currentcolor"><path d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12m0 2a8 8 0 1 1 0-16 8 8 0 0 1 0 16"/><path d="M14.301 9.485a1 1 0 0 1 1.398 1.43l-4.261 4.166a1 1 0 0 1-1.406-.008l-2.04-2.04a1 1 0 1 1 1.415-1.413l1.34 1.34z"/></g></svg>`
}, props, {
  newIcon: _checkCircle.default
}));
EmojiProductivityIcon.displayName = 'EmojiProductivityIcon';
var _default = exports.default = EmojiProductivityIcon;